module.exports = __webpack_public_path__ + "assets/img/twos.f7796c78.png";